export function getFormFieldLabel(label: string, rules: any) {
  if ((typeof rules === 'string' && rules.includes('required')) || rules.required) {
    return `${label} *`;
  }

  return label;
}
